import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse, LeadSourceMapping } from "@/lib/types";
import { baseFastApiLeadSourcesRoute } from "./firm-lead-source";

export function getFirmLeadSourceMappingsV2(leadSourceId: string) {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<LeadSourceMapping[]>
    >(`${baseFastApiLeadSourcesRoute}/${leadSourceId}/mappings`)
    .then((res) => res.data);
}

export function createFirmLeadSourceMappingV2(
  data: Pick<LeadSourceMapping, "key" | "leadSourceId" | "targetId">,
) {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<LeadSourceMapping>
    >(`${baseFastApiLeadSourcesRoute}/mappings`, data)
    .then((res) => res.data);
}

export function updateFirmLeadSourceMappingV2(
  data: Pick<LeadSourceMapping, "dateModified" | "id" | "leadSourceId"> &
    Partial<Pick<LeadSourceMapping, "key" | "targetId">>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<LeadSourceMapping>
    >(`${baseFastApiLeadSourcesRoute}/mappings`, data)
    .then((res) => res.data);
}

export function deleteFirmLeadSourceMappingV2(data: {
  leadSourceId: string;
  id: string;
}) {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<LeadSourceMapping>
    >(`${baseFastApiLeadSourcesRoute}/${data.leadSourceId}/mappings/${data.id}`)
    .then((res) => res.data);
}
